module.exports = __webpack_public_path__ + "static/img/jyszfl.79fca9a9.png";